import Director from 'director/build/director';

const router = new Director.Router();

export default router;

export const init = (routes, config) => {
  router.param('externalId', /([._a-zA-Z0-9-:%()]+)/);
  router.mount(routes);
  router.configure({
    convert_hash_in_init: false,
    html5history: true,
    ...config,
  });
  router.init();
  return router;
};
